module.exports = "/fast-coin/img/coin/anim/in/coin_in_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_004.png
// module id = 2274
// module chunks = 5